import axios from "axios";
import { client } from "@/main";
import {
  setFunctionalTestComplianceMutation,
  setIlluminationTestComplianceMutation,
  roomTypesQuery,
  fileQuery,
} from "@/graphql/query";

export default {
  async setTestCompliance({ dispatch, rootState, commit }, payload) {
    const { test_id, is_compliant, test_type, compliance_comment } = payload;
    commit("setTestCompliance", payload);
    try {
      if (test_type === "illumination") {
        await client.mutate({
          mutation: setIlluminationTestComplianceMutation,
          variables: {
            illumination_test_id: test_id,
            is_compliant,
            compliance_comment,
          },
        });
      }

      if (test_type === "functional") {
        await client.mutate({
          mutation: setFunctionalTestComplianceMutation,
          variables: {
            functional_test_id: test_id,
            is_compliant,
            compliance_comment,
          },
        });
      }
      dispatch(
        "projectStore/getProjectById",
        rootState.projectStore.project_id,
        { root: true }
      );
    } catch (error) {
      `Error setting test compliance: ${error}`;
    }
  },
  async uploadRoomFile({ commit }, file) {
    if (!file) return;
    commit("loaderStore/setIsLoading", true, { root: true });
    const filename = `${file.name} ${new Date().getTime()}`;

    const { data } = await client.query({
      query: fileQuery,
      fetchPolicy: "network-only",
      variables: {
        filename: filename,
        type: "room",
        is_upload: true,
      },
    });

    const url = data.file.url;
    return axios
      .put(url, file, {
        headers: {
          "Content-Type": file.type,
        },
      })
      .then(() => {
        commit("loaderStore/setIsLoading", false, { root: true });
        return filename;
      });
  },
  async getRoomTypes({ commit }, standard_id) {
    const {
      data: { room_types },
    } = await client.query({
      query: roomTypesQuery,
      variables: {
        standard_id,
      },
      fetchPolicy: "network-only",
    });
    commit("setRoomTypes", [...room_types.top, ...room_types.all]);
  },
};
